export function persistReducer(state){
    return {
        avail: state.avail,
        options: state.options,
        context: state.context
    };
}